import { useEffect } from 'react';

import { useRegionsBdmsStore } from '@pmp/stores';

// Store-backed: all consumers share one source of truth (single fetch, shared refresh),
// and revalidate on mount (stale-while-revalidate).
export const useRegionsAndBdms = () => {
  const { regions, bdms, loading, error, refresh } = useRegionsBdmsStore();

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { regions, bdms, loading, error, refresh };
};
